import React from 'react';
import PropTypes from 'prop-types';

import SupportStatusSelector from 'components/importer/support_status_selector';

export default function ImportRequestsHeader({
  importRequest,
  requestsIndexPath,
  supportStatusOptions,
  onSupportStatusChange
}) {
  return (
    <div className="page-header">
      <a href={requestsIndexPath} name="back-link">&lt; Back to Import Requests Index</a>
      <div className="title-bar d-inline-flex align-items-center w-100">
        <span className="h2 my-0 with-border">Import Request</span>
        <span className="h3 my-0 with-border">{importRequest.requestedBy} on {importRequest.dateSupportRequested}</span>
        <SupportStatusSelector
          activeStatus={importRequest.supportStatus}
          statusOptions={supportStatusOptions}
          onChange={onSupportStatusChange}
        />
      </div>
    </div>      
  );
}

ImportRequestsHeader.propTypes = {
  importRequest: PropTypes.shape({
    requestedBy: PropTypes.string,
    dateSupportRequested: PropTypes.string,
    supportStatus: PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string
    })
  }).isRequired,
  requestsIndexPath: PropTypes.string.isRequired,
  supportStatusOptions: PropTypes.array.isRequired,
  onSupportStatusChange: PropTypes.func.isRequired
};
